﻿import {String} from "../../Tools/Misc.js"

export class RoleModel {
    public Primarykey: string = String.GetEmptyGuid;
    public Libelle?: string;
}